import { useEffect } from 'react';

import { useNavigate } from '@reach/router';

import { decodeWorkshop } from '../../provider/models/decoderModel';
import { env } from '../../utils/env';

export default function WorkshopFormRedirector({ serviceId, slug }) {
  const navigate = useNavigate();
  useEffect(() => {
    //TODO use g4r.pl as a domain for shortener

    //ASK BACKEND FOR for full adress based on short name
    decodeWorkshop({ slug }).then((data) => {
      if (data.length === 0) {
        navigate(`./${serviceId}/`);
      }
      const address = `${env.PUBLIC_URL}/${serviceId}/${data.franchise_id}/${data.age}/${data.workshop_type_id}/${data.workshop_location_id}/${data.workshop_group_id}/formularzMiasto`;

      navigate(address);
    });
    // TODO: refactor
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
